var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"steps"},_vm._l((_vm.stepsArry),function(step){return _c('div',{key:step.num,class:step.class},[_c('em',[_vm._v(_vm._s(step.num))]),_c('span',[_vm._v(_vm._s(step.name))]),_c('div',{staticClass:"white-line"})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }